import { FlexSpace } from 'components/base'
import { Fonts, TextSize, Weight } from 'components/typography'
import styled from 'styled-components'

export const InputBox = styled(FlexSpace)`
  height: 40px;
  gap: 10px;
  margin-bottom: 10px;
  min-width: 240px;
`

export const Input = styled.input`
  font-family: ${Fonts.DMSans};
  appearance: textfield;
  text-align: right;
  border: none;
  outline: none;
  background: inherit;
  font-size: ${TextSize.two};
  font-weight: ${Weight.Bold};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0;
  width: 110px;
  color: ${({ theme }) => theme.primaryFontColor};
  height: 26px;
`
